module.exports = __webpack_public_path__ + "static/img/control.dc4fb1.svg";